import { api } from "@/lib/api";

const isPdf = (n) => /\.pdf$/i.test(n) && !/(^|\/)(__MACOSX|\.)/.test(n);
const isZip = (f) => /\.zip$/i.test(f.name) || f.type === "application/zip" || f.type === "application/x-zip-compressed";

const fromZip = async (f) => {
  const JSZip = (await import("jszip")).default;
  const z = await JSZip.loadAsync(f);
  const ents = Object.values(z.files).filter((e) => !e.dir && isPdf(e.name));
  return Promise.all(ents.map(async (e) => new File([await e.async("blob")], e.name.split("/").pop(), { type: "application/pdf" })));
};

const walk = (entry) => new Promise((res) => {
  if (entry.isFile) return entry.file((f) => res([f]), () => res([]));
  const r = entry.createReader(); const all = [];
  const next = () => r.readEntries(async (ents) => {
    if (!ents.length) return res((await Promise.all(all.map(walk))).flat());
    all.push(...ents); next();
  }, () => res([]));
  next();
});

// Drop event -> flat list of files, walking dropped folders.
export const droppedFiles = async (dt) => {
  const ents = [...(dt.items || [])].map((i) => i.webkitGetAsEntry?.()).filter(Boolean);
  if (!ents.length) return [...(dt.files || [])];
  return (await Promise.all(ents.map(walk))).flat();
};

// Files (PDFs, zips, folder contents) -> PDFs only, zips unpacked.
export const expandPdfs = async (files) => {
  const out = [];
  for (const f of files) {
    if (isZip(f)) { try { out.push(...(await fromZip(f))); } catch { /* unreadable zip */ } }
    else if (isPdf(f.webkitRelativePath || f.name)) out.push(f);
  }
  return out;
};

const score = (x) => { const c = x.confidence_score ?? x.confidence ?? 0; return Number(c) > 1 ? Number(c) / 100 : Number(c); };
const invalid = (x) => x.status === "invalid" || x.verdict === "invalid" || x.status === "bounced";

// Best non-invalid email for a person via §48 /verify; null when none.
export const bestEmail = async (f) => {
  const { data } = await api.post("/admin/email-verification/verify", { person_name: `${f.first_name} ${f.last_name || ""}`.trim(), company_name: f.company || "", company_domain: (f.company_website || "").replace(/^https?:\/\/(www\.)?/, "").split("/")[0] || undefined, guessed_emails: [] });
  const ok = (data.results || []).filter((x) => x.email && !invalid(x)).sort((a, b) => score(b) - score(a));
  return ok[0] ? { email: String(ok[0].email).toLowerCase(), score: score(ok[0]), catch_all: !!ok[0].catch_all } : null;
};
